import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_live_pistakio: FaireBrandEntity = {
  token: "b_live_pistakio",
  type: "brand",
  name: "Pistakio",
  minimumOrderDollars: 45,
  tags: ["live-shopping", "food"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
